/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditLog } from '../models/AuditLog';
import type { DcdOwnershipComponent } from '../models/DcdOwnershipComponent';
import type { DcdOwnershipComponentSummary } from '../models/DcdOwnershipComponentSummary';
import type { DcdOwnershipService } from '../models/DcdOwnershipService';
import type { DcdOwnershipServiceReferenceDetail } from '../models/DcdOwnershipServiceReferenceDetail';
import type { DcdOwnershipServiceReferencesInfo } from '../models/DcdOwnershipServiceReferencesInfo';
import type { DcdOwnershipServiceSummary } from '../models/DcdOwnershipServiceSummary';
import type { Team } from '../models/Team';
import type { TeamEdit } from '../models/TeamEdit';
import type { TeamInfoFull } from '../models/TeamInfoFull';
import type { TeamLinksEdit } from '../models/TeamLinksEdit';
import type { TeamLinksResponse } from '../models/TeamLinksResponse';
import type { TeamResourcesEdit } from '../models/TeamResourcesEdit';
import type { TeamResourcesResponse } from '../models/TeamResourcesResponse';
import type { TeamWithCounts } from '../models/TeamWithCounts';
import type { TeamWithHierarchy } from '../models/TeamWithHierarchy';
import type { TeamWithHierarchyCounts } from '../models/TeamWithHierarchyCounts';
import type { TeamWithMembers } from '../models/TeamWithMembers';
import type { TeamWithParents } from '../models/TeamWithParents';
import type { WorkstreamBasic } from '../models/WorkstreamBasic';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TeamService {

    /**
     * All Employee Endpoint
     * @returns TeamWithHierarchy Successful Response
     * @throws ApiError
     */
    public static getTreeAllApiV1TeamsTreeGet(): CancelablePromise<TeamWithHierarchy> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/tree',
        });
    }

    /**
     * All Employee Endpoint
     * @returns TeamWithHierarchyCounts Successful Response
     * @throws ApiError
     */
    public static getTreeCountsAllApiV1TeamsTreecountsGet(): CancelablePromise<TeamWithHierarchyCounts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/treecounts',
        });
    }

    /**
     * Get Teams Area
     * @returns Team Successful Response
     * @throws ApiError
     */
    public static getTeamsAreaApiV1TeamAreaGet(): CancelablePromise<Array<Team>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/team/area',
        });
    }

    /**
     * Create
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static createApiV1TeamPost(
        requestBody: TeamEdit,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/team',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Archive
     * @param slug
     * @returns string Successful Response
     * @throws ApiError
     */
    public static archiveApiV1TeamSlugArchivePost(
        slug: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/team/{slug}/archive',
            path: {
                'slug': slug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Edit
     * Update a team.
     * @param slug
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static editApiV1TeamSlugPut(
        slug: string,
        requestBody: TeamEdit,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/team/{slug}',
            path: {
                'slug': slug,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Edit Team Links
     * @param slug
     * @param requestBody
     * @returns TeamLinksResponse Successful Response
     * @throws ApiError
     */
    public static editTeamLinksApiV1TeamsSlugLinksPut(
        slug: string,
        requestBody: TeamLinksEdit,
    ): CancelablePromise<TeamLinksResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/teams/{slug}/links',
            path: {
                'slug': slug,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Edit Team Resources
     * @param slug
     * @param requestBody
     * @returns TeamResourcesResponse Successful Response
     * @throws ApiError
     */
    public static editTeamResourcesApiV1TeamsSlugResourcesPut(
        slug: string,
        requestBody: TeamResourcesEdit,
    ): CancelablePromise<TeamResourcesResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/teams/{slug}/resources',
            path: {
                'slug': slug,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Teams Page Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getTeamsApiV1TeamsGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams',
        });
    }

    /**
     * Count Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getCountApiV1CountGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/count',
        });
    }

    /**
     * Team Endpoint
     * @param slug
     * @param includeSubteamMembers
     * @returns TeamInfoFull Successful Response
     * @throws ApiError
     */
    public static getTeamBySlugApiV1TeamsSlugSlugGet(
        slug: string,
        includeSubteamMembers?: (boolean | null),
    ): CancelablePromise<TeamInfoFull> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/slug/{slug}',
            path: {
                'slug': slug,
            },
            query: {
                'include_subteam_members': includeSubteamMembers,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Team Workstreams Endpoint
     * @param slug
     * @returns WorkstreamBasic Successful Response
     * @throws ApiError
     */
    public static getTeamWorkstreamsApiV1TeamsSlugSlugWorkstreamsGet(
        slug: string,
    ): CancelablePromise<Array<WorkstreamBasic>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/slug/{slug}/workstreams',
            path: {
                'slug': slug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Team Endpoint
     * @returns string Successful Response
     * @throws ApiError
     */
    public static seedApiV1TeamsSeedGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/seed',
        });
    }

    /**
     * Team Endpoint
     * @param slug
     * @returns TeamWithMembers Successful Response
     * @throws ApiError
     */
    public static getTeamMembersApiV1TeamsSlugSlugMembersGet(
        slug: string,
    ): CancelablePromise<TeamWithMembers> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/slug/{slug}/members',
            path: {
                'slug': slug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Team Endpoint
     * @param slug
     * @returns AuditLog Successful Response
     * @throws ApiError
     */
    public static getTeamLogsApiV1TeamsSlugLogsGet(
        slug: string,
    ): CancelablePromise<Array<AuditLog>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/{slug}/logs',
            path: {
                'slug': slug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Team Endpoint
     * @param slug
     * @returns TeamWithParents Successful Response
     * @throws ApiError
     */
    public static getHierarchyApiV1TeamsSlugHierarchyGet(
        slug: string,
    ): CancelablePromise<TeamWithParents> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/{slug}/hierarchy',
            path: {
                'slug': slug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Teams Endpoint
     * @param slugs
     * @returns Team Successful Response
     * @throws ApiError
     */
    public static getTeamBySlugsApiV1TeamsSlugsSlugsGet(
        slugs: string,
    ): CancelablePromise<Array<Team>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/slugs/{slugs}',
            path: {
                'slugs': slugs,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Team Endpoint
     * @returns TeamWithCounts Successful Response
     * @throws ApiError
     */
    public static getHierarchyForTeamApiV1TeamsHierarchyGet(): CancelablePromise<Array<TeamWithCounts>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/hierarchy',
        });
    }

    /**
     * Get Dcd Ownership Services
     * @param source
     * @returns DcdOwnershipServiceSummary Successful Response
     * @throws ApiError
     */
    public static getDcdOwnershipServicesApiV1TeamsOwnershipServicesGet(
        source?: ('rserver' | 'servicenow' | null),
    ): CancelablePromise<Array<DcdOwnershipServiceSummary>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/ownership/services',
            query: {
                'source': source,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Dcd Ownership Components
     * @param query
     * @returns DcdOwnershipComponentSummary Successful Response
     * @throws ApiError
     */
    public static getDcdOwnershipComponentsApiV1TeamsOwnershipGet(
        query?: (string | null),
    ): CancelablePromise<Array<DcdOwnershipComponentSummary>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/ownership',
            query: {
                'query': query,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Dcd Ownership Service References
     * @param serviceId
     * @param limit
     * @param offset
     * @returns DcdOwnershipServiceReferencesInfo Successful Response
     * @throws ApiError
     */
    public static getDcdOwnershipServiceReferencesApiV1TeamsOwnershipServicesServiceIdReferencesGet(
        serviceId: number,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<DcdOwnershipServiceReferencesInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/ownership/services/{service_id}/references',
            path: {
                'service_id': serviceId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Dcd Ownership Service
     * @param serviceId
     * @returns DcdOwnershipService Successful Response
     * @throws ApiError
     */
    public static getDcdOwnershipServiceApiV1TeamsOwnershipServicesServiceIdGet(
        serviceId: number,
    ): CancelablePromise<DcdOwnershipService> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/ownership/services/{service_id}',
            path: {
                'service_id': serviceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Dcd Ownership Component Reference
     * @param componentId
     * @param referenceId
     * @returns DcdOwnershipServiceReferenceDetail Successful Response
     * @throws ApiError
     */
    public static getDcdOwnershipComponentReferenceApiV1TeamsOwnershipComponentIdReferencesReferenceIdGet(
        componentId: number,
        referenceId: number,
    ): CancelablePromise<DcdOwnershipServiceReferenceDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/ownership/{component_id}/references/{reference_id}',
            path: {
                'component_id': componentId,
                'reference_id': referenceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Dcd Ownership Component
     * @param componentId
     * @returns DcdOwnershipComponent Successful Response
     * @throws ApiError
     */
    public static getDcdOwnershipComponentApiV1TeamsOwnershipComponentIdGet(
        componentId: number,
    ): CancelablePromise<DcdOwnershipComponent> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/teams/ownership/{component_id}',
            path: {
                'component_id': componentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
